module.exports = __webpack_public_path__ + "static/media/covid-19-symptoms-news.6dc208f3.jpg";